<template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        clearable
        :style="{ width: width, margin: margin }"
        :placeholder="placeholder"
        :multiple="multiple" >
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
        placeholder: {
            type: String,
            default: '合同状态'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [
                { value: '待审核', label: '待审核' },
                { value: '已寄出', label: '已寄出' },
                { value: '已收回', label: '已收回' },
                { value: '待打印签章寄出', label: '待打印签章寄出' },
                { value: '未收回', label: '未收回' },
                { value: '结束', label: '结束' }
            ],
            selectValue: null,
        }
    },
    mounted () {
        this.selectValue = this.value
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
            this.$emit('onChange', data)
        }
    }
}
</script>